import { render } from "./lights-race.vue?vue&type=template&id=49ee7f1f&scoped=true"
import script from "./lights-race.vue?vue&type=script&lang=js"
export * from "./lights-race.vue?vue&type=script&lang=js"

import "./lights-race.vue?vue&type=style&index=0&id=49ee7f1f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ee7f1f"]])

export default __exports__